/**
 * Общие для всех страниц скрипты
 */
import("./main");

/**
 * Данный скрипт реализовывает необходимый функционал стратовой страницы
 */
// Общий функционал баннера
import("./components/bannerSelect").then((module) => {
    module.initBanner();
});

// Управление нажатием на селект баннера
$(document).on("click", ".get-course__select", function () {
    import("./components/bannerSelect").then((module) => {
        module.handleBannerSelect($(this));
    });
});

window.onload = () => {
    // Базовые настройки IntersectionObserver
    const options = {
        // Родитель целевого элемента
        root: null,
        // Отступ
        rootMargin: "0px",
        // Процент пересечения целевого элемента
        threshold: 0.1,
    };

    // Определяем наблюдателя
    const observer = new IntersectionObserver((entries, observer) => {
        // Для каждого входимого элемента
        entries.forEach((entry) => {
            // Если элемент появился на экране в зоне видимости
            if (entry.isIntersecting) {
                let form = $(entry.target);

                if (!form.is("form")) {
                    form = form.find("form");
                }

                const formPhoneInput = form.find(".input__phone");

                // Загружаем скрипт обработки форм
                import("./components/newFormsLoader").then(
                    ({ newFormsLoader }) => {
                        newFormsLoader().then((module) => {
                            const { newPhoneInput, newForms } = module;

                            newPhoneInput.phoneInput(formPhoneInput);

                            form.on("submit", function (e) {
                                e.preventDefault();
                                e.stopPropagation();
                                e.stopImmediatePropagation();

                                newForms.defaultFormHandle(e, {
                                    done: () =>
                                        import("./components/localizedUrl").then(
                                            ({ getLocalizedUrl }) => {
                                                setTimeout(function () {
                                                    const url =
                                                        getLocalizedUrl(
                                                            "/thanks/",
                                                        );

                                                    window.location.href = url;
                                                }, 0);
                                            },
                                        ),
                                    showSuccessModal: false,
                                });
                            });
                        });
                    },
                );
            }
        });
    }, options);

    // Определяем наблюдаемые элементы
    const observedItems = document.querySelectorAll(".start-study-more__form");

    // К каждому наблюдаемому элементу
    observedItems.forEach((form) => {
        // подключаем IntersectionObserver
        observer.observe(form);
    });
};
